import { render } from "./CreateRoom.vue?vue&type=template&id=08d355d2&scoped=true"
import script from "./CreateRoom.vue?vue&type=script&lang=js"
export * from "./CreateRoom.vue?vue&type=script&lang=js"

import "./CreateRoom.vue?vue&type=style&index=0&id=08d355d2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d355d2"]])

export default __exports__